import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3930f158&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../../less/appSetting.less?vue&type=style&index=0&id=3930f158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930f158",
  null
  
)

export default component.exports